module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 224
// module chunks = 0 1